import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectionInternalAssetSettings, useUpdateProjectionInternalAssetItemSetting, useUpdateProjectionInternalAssetSetting } from '../../api';
import { useTotalSelectedBankableAssets } from '../exporter/scenarios/hooks';
import { SettingBoxBase, SettingBoxPositionTable } from '../settings-drawer';

export const AssetsWithJbSettings: FunctionComponent = () => {
    const { t } = useTranslation();
    const totalSelectedBankableAssets = useTotalSelectedBankableAssets();
    const { data: internalAssetsSettings } = useProjectionInternalAssetSettings();

    const updateInternalAssetsSettings = useUpdateProjectionInternalAssetSetting();
    const updateInternalAssetsItemSettings = useUpdateProjectionInternalAssetItemSetting();

    return (
        <SettingBoxBase
            title={t('assetsWithJB')}
            showWarningIcon={totalSelectedBankableAssets <= 0}
            warningText={t('noBankableAssetsWarning')}
            boxId={internalAssetsSettings?.id}
            toggled={internalAssetsSettings?.enabled}
            onToggle={updateInternalAssetsSettings}
            detail={
                <SettingBoxPositionTable
                    enabled={!!internalAssetsSettings?.enabled}
                    updateItemSettings={updateInternalAssetsItemSettings}
                    itemSettings={internalAssetsSettings?.itemsSettings ?? []}
                    totalAmount={internalAssetsSettings?.totalAmount ?? 0}
                    emptyStateMessage={t('settingsDrawerEmpty.assetsWithJb')}
                />
            }
        />
    );
};
